import React, { useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import WestIcon from "@mui/icons-material/West";
import ReactCardFlip from "react-card-flip";
import RightArrow from "../../../assets/rightArrow.png";

const serviceData = [
  {
    title: "Java Development",
    description:
      "Our comprehensive Java development services cover the entire spectrum of Java technologies, ensuring robust, scalable, and efficient solutions for your business needs. From core Java to advanced frameworks, we provide end-to-end development expertise.",
    flippedBGColor: "#FDE319",
    backgroundColor: "#F7EAE0",
  },
  {
    title: "Node JS",
    description:
      "Harness the power of Node.js for lightweight and fast server-side applications. Our Node.js development services excel in creating real-time applications, APIs, and scalable network applications. Benefit from a JavaScript-based environment that promotes rapid development and seamless integration.",
    backgroundColor: "#F7F7F7",
    flippedBGColor: "#FDE319",
  },
  {
    title: "Django",
    description:
      "Our Django development services focus on building web applications quickly and with precision. Django, a high-level Python web framework, allows us to create secure and maintainable applications. From content management systems to complex web solutions, we tailor Django to meet your unique requirements.",
    backgroundColor: "#EFF5F3",
    flippedBGColor: "#FDE319",
  },
  {
    title: "React JS",
    description:
      "Elevate your user interfaces with React JS development services. Our experts create dynamic and interactive web applications using this popular JavaScript library. Benefit from a component-based architecture that enhances code reusability, making your web applications more efficient and scalable.",
    backgroundColor: "#F7F7F7",
    flippedBGColor: "#FDE319",
  },
  {
    title: "Android, iOS Native",
    description:
      "Our mobile app development services cover both Android and iOS platforms natively. Craft user-centric and performance-driven applications tailored to the specific requirements of each platform. Leverage the unique features of Android and iOS to provide a seamless and optimised user experience.",

    backgroundColor: "#FFF9E5",
    flippedBGColor: "#FDE319",
  },
  {
    title: "Flutter",
    description:
      "Experience cross-platform development with Flutter. Our Flutter development services enable the creation of visually appealing and high-performance mobile applications for both Android and iOS. Enjoy faster development cycles and a single codebase that works across different platforms without compromising on quality.",
    backgroundColor: "#F7EAE0",
    flippedBGColor: "#FDE319",
  },
];

const Services = () => {
  const [isFlippedArray, setIsFlippedArray] = useState(
    new Array(serviceData.length).fill(false)
  );

  const flipCard = (index) => {
    const updatedFlippedArray = [...isFlippedArray];
    updatedFlippedArray[index] = !updatedFlippedArray[index];
    setIsFlippedArray(updatedFlippedArray);
  };

  return (
    <>
      <Typography
        fontFamily="Inter"
        fontSize="32px"
        fontWeight="300"
        textTransform="uppercase"
        borderBottom="1px solid #D9D9D9"
        paddingBottom="24px"
        marginTop="100px"
      >
        <span style={{ color: "#FFE000" }}>/ </span>services
      </Typography>

      <Grid container spacing={4} marginTop="34px">
        <Grid item lg={3} md={4} sm={6} xs={12}>
          <Card
            sx={{
              maxWidth: 370,
              height: 460,
              backgroundColor: "#fff9c3",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-around",
              boxShadow: "none",
            }}
          >
            <CardContent sx={{ p: 3.5 }}>
              <Typography
                fontFamily="Inter"
                lineHeight="normal"
                sx={{
                  fontSize: {
                    xs: "24px",
                    sm: "28px",
                    md: "32px",
                  },
                }}
                fontWeight="400"
              >
                What Service are you looking for?
              </Typography>
              <Typography
                fontFamily="Inter"
                lineHeight="normal"
                fontSize={{
                  xs: "12px",
                  sm: "14px",
                  md: "16px",
                }}
                fontWeight="500"
                marginTop={{
                  xs: "8px",
                  sm: "10px",
                  md: "15px",
                }}
              >
                We deliver tailored technology solutions that drive efficiency,
                scalability, and success.
              </Typography>
            </CardContent>
            <CardActions sx={{ px: 4, mt: 3, mb: 3 }}>
              <Button
                variant="contained"
                endIcon={<ArrowRightAltIcon />}
                style={{ backgroundColor: "#ffe000", color: "black" }}
                sx={{
                  borderRadius: "44px",
                  textTransform: "none",
                  width: "144px",
                  height: "55px",
                  boxShadow: "none",
                }}
              >
                Contact Us
              </Button>
            </CardActions>
          </Card>
        </Grid>
        {serviceData.map((service, index) => (
          <Grid item lg={3} md={4} sm={6} xs={12} key={index}>
            <ReactCardFlip
              flipDirection="horizontal"
              isFlipped={isFlippedArray[index]}
            >
              <Card
                sx={{ maxWidth: 370, height: 460 }}
                style={{
                  backgroundColor: service.backgroundColor,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  boxShadow: "none",
                }}
              >
                <CardContent sx={{ p: 3.5, mt: 24.9 }}>
                  <Typography
                    fontFamily="Inter"
                    fontSize="24px"
                    fontWeight="400"
                  >
                    {service.title}
                  </Typography>
                </CardContent>
                <CardActions
                  sx={{
                    mb: 3,
                    display: "flex",
                    alignItems: "flex-end",
                    flexDirection: "column",
                  }}
                >
                  <Button
                    variant="text"
                    sx={{ borderRadius: "20px" }}
                    style={{ color: "#000000" }}
                    onClick={() => flipCard(index)}
                  >
                    <img src={RightArrow} alt="" style={{}} />
                  </Button>
                </CardActions>
              </Card>

              <Card
                sx={{ maxWidth: 370, height: 460 }}
                style={{
                  backgroundColor: service.flippedBGColor,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <CardContent sx={{ p: 3.5 }}>
                  <Typography
                    fontFamily="Inter"
                    fontSize="24px"
                    fontWeight="400"
                  >
                    {service.title}
                  </Typography>
                  <Typography
                    fontFamily="Inter"
                    fontSize="14px"
                    fontWeight="300"
                    fontStyle="italic"
                    marginTop="20px"
                  >
                    {service.description}
                  </Typography>
                </CardContent>
                <CardActions
                  sx={{
                    mb: 2,
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <Button
                    variant="text"
                    sx={{ borderRadius: "20px" }}
                    style={{ color: "#000000" }}
                    onClick={() => flipCard(index)}
                  >
                    <WestIcon />
                  </Button>
                </CardActions>
              </Card>
            </ReactCardFlip>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default Services;
